module.exports = __webpack_public_path__ + "static/img/1.e03671c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/sp/1.png
// module id = Mc6W
// module chunks = 0